import { StyleSheet } from 'aphrodite';
import COLORS from '../../../../library/colors';

const Color = require('color');

const styles = StyleSheet.create({
  root: {
    color: COLORS.allureRed,
    ':active': {
      background: `${Color(COLORS.allureRed).lighten(0.9)}`,
      border: `1px solid ${Color(COLORS.allureRed).lighten(0.48)}`,
    }
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/button/red-button/red-button-styles.js